import { dateFNS } from '@gogame/intl-ts';
import { useMutation } from '@gogame/query';

import { createNews } from '../../sources/news';
import { create } from '../queryKeyFactory';
import { useUpdateReleaseDate } from './useUpdateReleaseDate';

export const useCreateNews = () => {
  const [updateReleaseDate] = useUpdateReleaseDate();
  const createMutation = useMutation(create(), createNews, {
    successMessage: () => 'News was created',
    onSuccess: (values) => {
      if (values?.type === 1) {
        return updateReleaseDate({
          date: dateFNS.addDays(new Date(), 14),
        });
      }
    },
  });
  return [createMutation.mutateAsync, createMutation];
};
